/* -------------------------------------------------------------------------- */
/*                                 Schema Categories                          */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const category = new schema.Entity('categories', {}, { idAttribute: 'categoryId' });
export const categories = new schema.Array(category);
